import React from 'react';
import { useParams } from 'react-router';

import { thirdPartyTransferDetailsURL } from '@admin/config/routes';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useThirdPartyTransferCreateMutation } from '@admin/schema';

import { PageHeader } from '../helpers/page_header';
import { Breadcrumbs } from './breadcrumbs';
import { FormValues, ThirdPartyTransferForm } from './form';

export const ThirdPartyTransferCreate: React.FC = () => {
  useTitle('New Third-Party Transfer');
  const { accountID } = useParams<{ accountID: string }>();

  const [execute, { loading: saving, data }] = useThirdPartyTransferCreateMutation({
    client,
    onCompleted: ({ thirdPartyTransferCreate }) => {
      if (thirdPartyTransferCreate.thirdPartyTransfer)
        window.location.href = thirdPartyTransferDetailsURL(accountID, thirdPartyTransferCreate.thirdPartyTransfer.id);
    },
  });

  const save = (input: FormValues) => {
    const { allItemsAcknowledged, ...filteredInput } = input;
    execute({ variables: { input: { ...filteredInput, accountID } } });
  };

  const error = data?.thirdPartyTransferCreate?.error;

  return (
    <>
      <PageHeader>
        <Breadcrumbs />
      </PageHeader>
      <ThirdPartyTransferForm kind="create" save={save} saving={saving} error={error} />
    </>
  );
};
